
import { connect } from 'react-redux';
import CustomerDetails from './CustomerDetails';
import { setProgressBarStatus } from '../../redux/actions/progressBar';

const mapStateToProps = null;

const mapDispatchToProps = {
  setProgressBarStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerDetails);
